'use client'

import { getLogger } from '@logtape/logtape'
import { env } from '@shared/config/env'
import { usePathname, useSearchParams } from 'next/navigation'
import { useEffect } from 'react'

import { VStack } from '@podo-app/design-system-temp'

import { useNativeBridgeStore } from '../../models'

const logger = getLogger(['web', 'debugger', 'client-only'])

type Props = {
  cookies: Record<string, string>
}

export const ClientOnlyDebugger = ({ cookies }: Props) => {
  const pathname = usePathname()
  const searchParams = useSearchParams()
  const nativeBridgeStore = useNativeBridgeStore()

  useEffect(() => {
    logger.info('client-debugger-navigation', {
      pathname,
      searchParams: Object.fromEntries(searchParams?.entries() ?? []),
    })
  }, [pathname, searchParams])

  // 디버그 오버레이는 로컬/개발 환경에서만 노출한다.
  // (staging/temp/qa/production 등 실서비스 도메인에서는 절대 렌더링되지 않도록 화이트리스트로 강하게 제한)
  const isDebugEnv = env.NEXT_PUBLIC_APP_ENV === 'local' || env.NEXT_PUBLIC_APP_ENV === 'development'

  return (
    isDebugEnv && (
      <VStack className="fixed top-[50px] right-2.5 gap-2">
        <button
          className="w-[30px] h-[30px] rounded-full bg-primary text-white shadow-lg flex items-center justify-center hover:bg-primary/90 transition-colors z-[100]"
          onClick={() => {
            alert(`${pathname}?${searchParams.toString()}`)
          }}
        >
          pathname
        </button>
        <button
          className="w-[30px] h-[30px] rounded-full bg-primary text-white shadow-lg flex items-center justify-center hover:bg-primary/90 transition-colors z-[100]"
          onClick={() => {
            alert(
              Object.entries(cookies ?? {})
                .map(([key, value]) => `${key}: ${value}`)
                .join('\n'),
            )
            navigator.clipboard.writeText(JSON.stringify(cookies))
          }}
        >
          cookies
        </button>
        {nativeBridgeStore.from === 'APP' && (
          <button
            className="w-[30px] h-[30px] rounded-full bg-primary text-white shadow-lg flex items-center justify-center hover:bg-primary/90 transition-colors z-[100]"
            onClick={() => {
              alert(
                Object.entries(
                  Object.fromEntries(
                    Object.entries(nativeBridgeStore ?? {}).filter(([_, value]) => typeof value !== 'function'),
                  ),
                )
                  .map(([key, value]) => `${key}: ${value}`)
                  .join('\n'),
              )
            }}
          >
            Native
          </button>
        )}
      </VStack>
    )
  )
}
